import { render, staticRenderFns } from "./cooperationLog.vue?vue&type=template&id=18f870d5&scoped=true"
import script from "./cooperationLog.vue?vue&type=script&lang=js"
export * from "./cooperationLog.vue?vue&type=script&lang=js"
import style0 from "./cooperationLog.vue?vue&type=style&index=0&id=18f870d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f870d5",
  null
  
)

export default component.exports